import { endPoints, API_ROOT } from "../../appSettings";
import { adalApiFetch } from "../../authProvider";

export function getUnits(roleNameId) {
  return (dispatch) => {
    return adalApiFetch(
      fetch,
      `${API_ROOT}/units${roleNameId && `?roleNameId=${roleNameId}`}`,
      {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      },
      dispatch
    ).then((response) => response.json());
  };
}

export const getFamilies = (roleNameId) => {
  return (dispatch) => {
    return adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.authorization}/role-names/${roleNameId}/products`,
      {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      },
      dispatch
    ).then((response) => response.json());
  };
};
